import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { get } from 'lodash';
import Table from '../../modules/table';
import { getTransactionHistorySearch } from '../../store/actions/transactions-history';
import { RootState } from '../../types';
import { TRANSACTION_FILTERS, TRANSACTION_TYPE } from '../../types';
import RowComponent from './row-component/row-component';
import { COLUMNS, COLUMNS_EXCHANGE } from './columns';
import Filters from './filters';

interface IProps {
  type: TRANSACTION_TYPE;
}

const BASE_PAGE_SIZE = 8;

export const AVAILABLE_TRANSACTION_DETAILS = {
  CREDIT: 'CREDIT',
  CREDIT_REPAYMENT: 'CREDIT_REPAYMENT',
  PURCHASE: 'PURCHASE',
  ISSUE_PAYMENT: 'ISSUE_PAYMENT',
  ISSUE: 'ISSUE',
  SALE: 'SALE',
  EXCHANGE: 'EXCHANGE',
  REDEEM: 'REDEEM',
};

const TransactinHistoryContainer = ({ type }: IProps) => {
  const history = useHistory();
  const isLast = useSelector(
    (state: RootState) => state.transactionsHistory.data.pagination.isLast
  );
  const dataHistory = useSelector(
    (state: RootState) => state.transactionsHistory.data.searchHistory
  );

  const [filters, setFilters] = useState({
    page: {
      number: 0,
      size: 8,
    },
  });
  const dispatch = useDispatch();

  useEffect(() => {
    let types: TRANSACTION_TYPE[] = [];
    if (type) {
      if (type === 'CREDIT') types = ['CREDIT', 'CREDIT_REPAYMENT'];
      else if (type === 'ISSUE') types = ['ISSUE', 'ISSUE_PAYMENT'];
      else types = [type];
    }
    dispatch(
      getTransactionHistorySearch({
        types,
        ...(filters as Omit<TRANSACTION_FILTERS, 'accountId' | 'types'>),
      })
    );
  }, [type, filters]);

  const changeFilters = (data: Record<string, any>) => {
    setFilters({
      ...filters,
      ...data,
    });
  };

  const onLoadMore = () =>
    setFilters({
      ...filters,
      page: {
        size: BASE_PAGE_SIZE,
        number: get(filters, 'page.number', 0) + 1,
      },
    });

  return (
    <>
      <Filters onChange={changeFilters} isCredit={type === 'CREDIT'} />
      <Table
        data={dataHistory}
        columns={type === 'EXCHANGE' ? COLUMNS_EXCHANGE : COLUMNS}
        RowComponent={RowComponent}
        onRowClick={({
          id,
          type: transactionType,
          isHybrid,
          specialFields,
        }: {
          id: string;
          type: string;
          isHybrid?: boolean;
          specialFields?: {
            tokenId: string;
          };
        }) => {
          switch (transactionType) {
            case AVAILABLE_TRANSACTION_DETAILS.PURCHASE:
              history.push(`history/sign-info/${id}`, {
                id,
                isHistory: true,
              });
              break;
            case AVAILABLE_TRANSACTION_DETAILS.SALE:
              history.push(`history/selling-sign-info/${id}`, {
                id,
                isHistory: true,
              });
              break;
            case AVAILABLE_TRANSACTION_DETAILS.CREDIT:
              history.push(`credit/details/${id}`, {
                id,
                isHistory: true,
              });
              break;
            case AVAILABLE_TRANSACTION_DETAILS.CREDIT_REPAYMENT:
              history.push(`credit/details/${id}`, {
                id,
                isHistory: true,
              });
              break;
            case AVAILABLE_TRANSACTION_DETAILS.ISSUE_PAYMENT:
              history.push(
                `history/${isHybrid ? 'hybrid' : 'cfa'}-info/${id}`,
                { id, isHistory: true }
              );
              break;
            case AVAILABLE_TRANSACTION_DETAILS.ISSUE:
              history.push(
                `history/${isHybrid ? 'hybrid' : 'cfa'}-info/${id}`,
                { id, isHistory: true }
              );
              break;
            case AVAILABLE_TRANSACTION_DETAILS.EXCHANGE:
              history.push(`history/exchange-info/${id}`, {
                id,
                isHistory: true,
              });
              break;
            case AVAILABLE_TRANSACTION_DETAILS.REDEEM:
              history.push(`/assets/details/${specialFields!.tokenId}`, {
                id: specialFields!.tokenId,
              });
              break;
            default:
              history.push(`history/details/${id}`, { id });
              break;
          }
        }}
        onLoadMore={onLoadMore}
        footer={!isLast}
      />
    </>
  );
};

export const AllTransactionsHistory = () => (
  <TransactinHistoryContainer type={null} />
);

export const LoansTransactionsHistory = () => (
  <TransactinHistoryContainer type="CREDIT" />
);

export const SaleTransactionsHistory = () => (
  <TransactinHistoryContainer type="SALE" />
);

export const PurchaseTransactionsHistory = () => (
  <TransactinHistoryContainer type="PURCHASE" />
);

export const IssueTransactionsHistory = () => (
  <TransactinHistoryContainer type="ISSUE" />
);

export const ExchangeTransactionsHistory = () => (
  <TransactinHistoryContainer type="EXCHANGE" />
);

export const RedeemTransactionsHistory = () => (
  <TransactinHistoryContainer type="REDEEM" />
);
